/**
 * Wait for the specified number of milliseconds.
 *
 * @param ms - The number of milliseconds to wait.
 */
export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
